import type { ChipVariant } from './BaseChip.types'
export const VARIANT_CLASSES: { [prop in ChipVariant]: string } = {
  default: '',
  purple: 'chip_purple',
  green: 'chip_green',
  transparent: 'chip_transparent',
  yellow: 'chip_yellow',
}
export const DELETE_EVENT_NAME = 'delete'
export const DEFAULT_TEXT = 'No Text'
export const TEST_ID = 'BaseChip'
